import React, { createContext, useContext, useState, useEffect } from 'react';

const IdentityContext = createContext();

export const IdentityProvider = ({ children }) => {
  // 'real' or 'shadow'
  const [identityMode, setIdentityMode] = useState(() => {
    // Force shadow mode for now
    return 'shadow';
  });
  
  const [showComingSoonModal, setShowComingSoonModal] = useState(false);

  useEffect(() => {
    localStorage.setItem('spark_identity_mode', 'shadow');
  }, [identityMode]);

  const toggleIdentity = () => {
    setShowComingSoonModal(true);
    // setIdentityMode(prev => prev === 'real' ? 'shadow' : 'real');
  };

  return (
    <IdentityContext.Provider value={{ identityMode, toggleIdentity, setIdentityMode }}>
      {children}
      {showComingSoonModal && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80 px-4">
          <div className="bg-[#111] border border-gray-800 rounded-2xl w-full max-w-sm p-6 flex flex-col items-center text-center animate-fade-in-up">
            <h3 className="text-xl font-bold text-white mb-3">Coming Soon to Web!</h3>
            <p className="text-gray-400 text-[15px] mb-6 leading-relaxed">
              Reality Mode will be available for web soon! Meanwhile, jump in and try it on our mobile app.
            </p>
            <div className="flex flex-col gap-3 w-full">
              <a 
                href="https://play.google.com/store/apps/details?id=com.sparkthegenzapp" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="w-full py-3.5 bg-[#0BD9E5]/10 border border-[#0BD9E5]/50 text-[#0BD9E5] font-bold rounded-xl hover:bg-[#0BD9E5]/20 transition-colors flex items-center justify-center gap-2"
              >
                 Get the App
              </a>
              <button 
                onClick={() => setShowComingSoonModal(false)} 
                className="w-full py-3.5 bg-[#1a1a1a] border border-gray-600 text-white font-bold rounded-xl hover:bg-gray-800 transition-colors"
              >
                 Dismiss
              </button>
            </div>
          </div>
        </div>
      )}
    </IdentityContext.Provider>
  );
};

export const useIdentity = () => useContext(IdentityContext);
